import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function getEducationBackgroundByApplicationId(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.education_background.getEducationBackgroundByApplicationId(id);

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { educationBg } = response.data;

		dispatch({
			type: ActionTypes.GET_EDUCATION_BACKGROUND_BY_APPLICATION_ID_SUCCESS,
			payload: {
				educationBackground: educationBg,
				loading: false
			}
		});
	};
}

export function onEducationBackgroundSubmit({ id, fields }) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_EDUCATION_BACKGROUND_REQUEST,
			payload: {
				loadingSubmit: true
			}
		});

		const body = {
			education_bg: fields
		};


		let response;
		if (!id) {
			response = await API.education_background.createEducationBackground(body);
		} else {
			response = await API.education_background.updateEducationBackground(id, body);
		}

		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.SUBMIT_EDUCATION_BACKGROUND_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { educationBg } = response.data;

		dispatch({
			type: ActionTypes.SUBMIT_EDUCATION_BACKGROUND_SUCCESS,
			payload: {
				educationBackground: educationBg,
				loadingSubmit: false,
				meta: response.meta
			}
		});
	};
}

export function resetEducationBackgroundPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_EDUCATION_BACKGROUND_PAGE
		});
	};
}

export function resetEducationBackgroundMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_EDUCATION_BACKGROUND_META
		});
	};
}